import { times } from 'lodash/fp'

import { Box, Flex, HStack, Skeleton, SkeletonText } from '@masterplandev/ui'

export const LearnpathsTranslationsLoader = () => (
  <Box p={6} w="full" opacity={0.7}>
    <Flex align="center" h={6} justify="space-between" mb={2}>
      <Skeleton rounded="md" h={4} w={24} />
      <Skeleton rounded="md" h={4} w={32} />
    </Flex>
    <Box
      border="1px solid"
      borderColor="mp2.neutralLight.300A"
      rounded="lg"
      overflow="hidden">
      <Box borderBottom="1px solid" borderColor="mp2.neutralLight.300A" h={8} />
      {times(
        (i) => (
          <Flex
            key={i}
            align="center"
            bg={i % 2 === 1 ? 'mp2.neutralLight.100A' : undefined}
            h={10}
            px={4}
            py={2}>
            <Box w={16}>
              <Skeleton rounded="full" h={5} w={9} />
            </Box>
            <Box flex="1">
              <SkeletonText noOfLines={1} skeletonHeight={3} w="40%" />
            </Box>
            <HStack mr={14}>
              <Skeleton rounded="full" h={1} w={16} />
              <Skeleton rounded="md" h={3} w={6} />
            </HStack>
          </Flex>
        ),
        4,
      )}
    </Box>
  </Box>
)
